import { Injectable } from "@angular/core";
import { UtilsService } from "./utils/utils.service";
import { IDropdownModel, DropdownModel } from "../models/dropdown/dropdown.model";
import { IFabricColor, FabricColor } from "../models/order-specs/fabric-color.model";
import { IOrderSpecs, IOrderModel } from "@models";

@Injectable()
export class OrderSpecsService {
	constructor() { }

	getShipTo(): IDropdownModel[] {
		return [new DropdownModel('Customer', 'Customer'),
		new DropdownModel('Builder', 'Builder'),
		new DropdownModel('Dealer', 'Dealer')];
	}

	getCarriers(): IDropdownModel[] {
		return [
			new DropdownModel('ABF', 'ABF'),
			new DropdownModel('Conway Freight', 'Conway Freight'),
			new DropdownModel('Conway', 'Conway'),
			new DropdownModel('Corlett', 'Corlett'),
			new DropdownModel('DATS', 'DATS'),
			new DropdownModel('Dayton', 'Dayton'),
			new DropdownModel('Enterprise', 'Enterprise'),
			new DropdownModel('Estes', 'Estes'),
			new DropdownModel('Fed Ex', 'Fed Ex'),
			new DropdownModel('FedEx Air', 'FedEx Air'),
			new DropdownModel('FedEx Express', 'FedEx Express'),
			new DropdownModel('FedEx Economy', 'FedEx Economy'),
			new DropdownModel('Fed Ex International', 'Fed Ex International'),
			new DropdownModel('Fed Ex International Economy', 'Fed Ex International Economy'),
			new DropdownModel('Fed Ex International Express', 'Fed Ex International Express'),
			new DropdownModel('FedEx International Ground', 'FedEx International Ground'),
			new DropdownModel('FedEx International Priority', 'FedEx International Priority'),
			new DropdownModel('FedEx Priority', 'FedEx Priority'),
			new DropdownModel('FedEx Ground', 'FedEx Ground'),
			new DropdownModel('Holland', 'Holland'),
			new DropdownModel('Horizon', 'Horizon'),
			new DropdownModel('North Park Transit', 'North Park Transit'),
			new DropdownModel('North Park Tansit', 'North Park Tansit'),
			new DropdownModel('Old Dominion', 'Old Dominion'),
			new DropdownModel('Reddaway', 'Reddaway'),
			new DropdownModel('Republic', 'Republic'),
			new DropdownModel('Roadway', 'Roadway'),
			new DropdownModel('Robey', 'Robey'),
			new DropdownModel('Standard Forwarding', 'Standard Forwarding'),
			new DropdownModel('UPS', 'UPS'),
			new DropdownModel('UPS 2nd Day Air', 'UPS 2nd Day Air'),
			new DropdownModel('UPS 3rd Day Select', 'UPS 3rd Day Select'),
			new DropdownModel('UPS Freight', 'UPS Freight'),
			new DropdownModel('UPS Ground', 'UPS Ground'),
			new DropdownModel('UPS Next Day Air', 'UPS Next Day Air'),
			new DropdownModel('Will Call', 'Will Call'),
			new DropdownModel('XPO Logistics', 'XPO Logistics'),
			new DropdownModel('Yellow', 'Yellow'),
			new DropdownModel('Other', 'Other')];

	}


	getUnitLocations(): IDropdownModel[] {
		return [new DropdownModel("Recessed", "Recessed"),
		new DropdownModel("Deck Mount", "Deck Mount")]
	}

	getMotorSides(): IDropdownModel[] {
		return [new DropdownModel("Left", "Left"),
			new DropdownModel("Right", "Right"),
			new DropdownModel("TBD", "TBD")]
	}

	getPoolTypes(): IDropdownModel[] {
		return [new DropdownModel("Fiberglass", "Fiberglass"),
		new DropdownModel("Gunite", "Gunite")]
	}

	getGuideTypes(isReplacementCover: boolean): IDropdownModel[] {
		let guideTypes: IDropdownModel[] = [];

		if (isReplacementCover)
			guideTypes = [new DropdownModel("Underguide", "Underguide"),
			new DropdownModel("Topguide", "Topguide")]
		else {
			guideTypes = [new DropdownModel("Encapsulated", "Encapsulated"),
			new DropdownModel("Topguide", "Topguide"),
			new DropdownModel("Hanging", "Hanging")]
		}

		return guideTypes;
	}

	getHousingMountingKits(): IDropdownModel[] {
		return [new DropdownModel("None", "None"),
			new DropdownModel("Vinyl Liner", "Vinyl Liner"),
			new DropdownModel("Fiberglass", "Fiberglass"),
			new DropdownModel("Free Standing", "Free Standing")]
	}

	getEncapsulationTypes(): IDropdownModel[] {
		return [new DropdownModel("Vinyl Liner", "Vinyl Liner"),
		new DropdownModel("Fiberglass", "Fiberglass"),
		new DropdownModel("Gunite", "Gunite")]
	}

	getClipOnCopingTypes(): IDropdownModel[] {
		return [new DropdownModel("Rounded", "Rounded"),
		new DropdownModel("Bullnose", "Bullnose")]
	}

	getLidTypes(): IDropdownModel[] {
		return [new DropdownModel("None", "None"),
		new DropdownModel("Flush Lid", "Flush Lid"),
		new DropdownModel("Flat Lid", "Flat Lid"),
		new DropdownModel("Stone Lid", "Stone Lid")]
	}

	getOEMs(guideType: string): IDropdownModel[] {
		let oems: IDropdownModel[] = [new DropdownModel("Integra", "Integra"),
		new DropdownModel("Coverstar", "Coverstar"),
		new DropdownModel("Coverpools", "Coverpools"),
		new DropdownModel("T3 Universal track w/Wheels", "T3 Universal track w/Wheels"),
		new DropdownModel("Aquamatic", "Aquamatic"),
		new DropdownModel("PCS", "PCS"),
		new DropdownModel("APC", "APC")];

		if (guideType === 'Underguide') {
			oems = [new DropdownModel("Integra", "Integra"),
			new DropdownModel("Coverstar", "Coverstar"),
			new DropdownModel("Coverpools", "Coverpools"),
			new DropdownModel("Coverpools T4 Dual Race", "Coverpools T4 Dual Race"),
			new DropdownModel("Coverpools T3 Adj Glider Undertrack, Snap top or Universal Glider", "Coverpools T3 Adj Glider Undertrack, Snap top or Universal Glider"),
			new DropdownModel("Coverpools T3 Non-ADJ Glider Undertrack", "Coverpools T3 Non-ADJ Glider Undertrack"),
			new DropdownModel("Coverpools T4 Under track California corner", "Coverpools T4 Under track California corner"),
			new DropdownModel("Coverpools T3 Under track California corner", "Coverpools T3 Under track California corner"),
			new DropdownModel("Aquamatic", "Aquamatic"),
			new DropdownModel("PCS", "PCS"),
			new DropdownModel("APC", "APC")]
		}
		else if (guideType === 'Topguide') {
			oems = [new DropdownModel("Integra", "Integra"),
			new DropdownModel("Coverstar", "Coverstar"),
			new DropdownModel("Coverpools", "Coverpools"),
			new DropdownModel("Aquamatic", "Aquamatic"),
			new DropdownModel("PCS", "PCS"),
			new DropdownModel("APC", "APC")];
		}

		return oems;
	}

	getFabricColors(): IFabricColor[] {
		return [new FabricColor("Royal Blue", "#1d71c7"),
		new FabricColor("Navy", "#083c8f"),
		new FabricColor("Charcoal", "#81817f"),
		new FabricColor("Gray", "#c4c3bf"),
		new FabricColor("Tan", "#dfd2b2"),
		new FabricColor("Mocha", "#947963")]

	}

	getWebbingTypes(isReplacementCover: boolean, oem: string): IDropdownModel[] {
		let webbingTypes: IDropdownModel[] = [];

		if (isReplacementCover) {
			webbingTypes = [new DropdownModel("Color Matched Heat Sealed", "Color Matched Heat Sealed"),
			new DropdownModel("White Heat sealed", "White Heat sealed"),
			new DropdownModel("Sewn Dacron White", "Sewn Dacron White"),
			new DropdownModel("Color Matched Dacron", "Color Matched Dacron")];

			switch (oem) {
				case 'Coverpools T3 Adj Glider Undertrack, Snap top or Universal Glider':
				case 'Coverpools T3 Universal track w/Wheels':
				case 'Coverpools T3 Non-ADJ Glider Undertrack':
				case 'Coverpools T3 Under track California corner':
					webbingTypes = [new DropdownModel("Color Matched Dacron", "Color Matched Dacron")];
					break;

				case 'Coverpools T4 Dual Race':
				case 'Coverpools T4 Under track California corner':
					webbingTypes = [new DropdownModel("Color Matched Heat Sealed", "Color Matched Heat Sealed")];
					break;
			}
		}
		else {
			webbingTypes = [new DropdownModel("Color Matched Heat Sealed", "Color Matched Heat Sealed"),
			new DropdownModel("White Heat sealed", "White Heat sealed")];
		}

		return webbingTypes;
	}


	getSliderTypes(): IDropdownModel[] {
		return [new DropdownModel("No Slider", "No Slider"),
		new DropdownModel("IPC Slider", "IPC Slider"),
		new DropdownModel("IPC Slider (PCS Modified)", "IPC Slider (PCS Modified)"),
		new DropdownModel("CoverPools Replacement Slider Assembly", "CoverPools Replacement Slider Assembly"),
		new DropdownModel("Aquamatic Replacement Slider Assembly", "Aquamatic Replacement Slider Assembly"),
		new DropdownModel("Coverstar Replacement Slider 403 Assembly", "Coverstar Replacement Slider 403 Assembly"),
		new DropdownModel("Coverstar Replacement Slider 801 Assembly", "Coverstar Replacement Slider 801 Assembly")]
	}

	getLeadingEdgeBarTypes(isReplacementCover: boolean): IDropdownModel[] {
		let leadingEdgeBarTypes: IDropdownModel[] = [];

		if (isReplacementCover) {
			leadingEdgeBarTypes = [
				new DropdownModel("1 Inch Flat", "1 Inch Flat"),
				new DropdownModel("1 ¼ Inch Flat", "1 ¼ Inch Flat"),
				new DropdownModel("2 Inch Round", "2 Inch Round"),
				new DropdownModel("2 ½ Inch Rectangle", "2 ½ Inch Rectangle"),
				new DropdownModel("3 Inch Round", "3 Inch Round"),
				new DropdownModel("4 Inch Round", "4 Inch Round")]
		}
		else {
			leadingEdgeBarTypes = [new DropdownModel("2 ½ Rectangle", "2 ½ Rectangle"),
				new DropdownModel("Spliced 2 ½ Rectangle", "Spliced 2 ½ Rectangle")]
		}

		return leadingEdgeBarTypes;
	}

	getRollupTubeTypes(): IDropdownModel[] {
		return [
			new DropdownModel("5in Extruded", "5in Extruded"),
			new DropdownModel("6in Extruded", "6in Extruded"),
			new DropdownModel("Spliced 5in Extruded", "Spliced 5in Extruded"),
			new DropdownModel("Spliced 6in Extruded", "Spliced 6in Extruded")]
	}

	// 6/24/20 - Per Toby's request, changed rope attachments to the following (see email)
	// 11/12/20 - Rope attachments are only IPC if a system
	// 9/13/22 - Per Clint, remove all Detachable ropes from the system
	// 10/21/22 - Per Earnest, add detachable ropes back in
	getRopeAttachmentTypes(isSystem: boolean): IDropdownModel[] {
		if (isSystem === true) {
			return [new DropdownModel("No Rope", "No Rope"),
				new DropdownModel("Detachable w/IPC tab", "Detachable w/IPC tab"),
				new DropdownModel("Continuous w/IPC tab", "Continuous w/IPC tab"),
				new DropdownModel("Detachable 3 hole tab", "Detachable 3 hole tab"),
				new DropdownModel("Continuous 3 hole tab", "Continuous 3 hole tab")]
		}
		else {
			return [new DropdownModel("No Rope", "No Rope"),
				new DropdownModel("Detachable w/IPC tab", "Detachable w/IPC tab"),
				new DropdownModel("Continuous w/IPC tab", "Continuous w/IPC tab"),
				new DropdownModel("Continuous", "Continuous"),
				new DropdownModel("Detachable w/3 hole tab", "Detachable w/3 hole tab"),
				new DropdownModel("Continuous w/3 hole tab", "Continuous w/3 hole tab")]
		}
	}

	getCoverOptions(): IDropdownModel[] {
		return [new DropdownModel("None", "None"),
		new DropdownModel("Std Mesh Panel (leading edge)", "Std Mesh Panel (leading edge)"),
			new DropdownModel("Custom Mesh Panel", "Custom Mesh Panel"),
			new DropdownModel(`1" Set back corner`, `1" Set back corner`),
			new DropdownModel(`2" Setback Corners`, `2" Setback Corners`),
			new DropdownModel(`4" Setback Corners`, `4" Setback Corners`),
			new DropdownModel(`Winged Corner`, `Winged Corner`)		]

	}

	calcSystemSize(orderSpecs: IOrderSpecs, addSlackAndRollerWrap: boolean = false): number {
		const slack = orderSpecs.slack || 0;
		const rollerWrap = orderSpecs.rollerWrap || 0;

		const gsFeet = orderSpecs.guideSpaceFeet || 0;
		const gsInches = (orderSpecs.guideSpaceInches || 0) + ((addSlackAndRollerWrap === true) ? slack : 0);

		const glFeet = (orderSpecs.guideLengthFeet || 0) + ((addSlackAndRollerWrap === true) ? rollerWrap : 0);
		const glInches = (orderSpecs.guideLengthInches || 0);

		const gsTotalInches = (gsFeet * 12) + gsInches;
		const glTotalInches = (glFeet * 12) + glInches;

		const size = (gsTotalInches * glTotalInches) / 144;
		return UtilsService.round(size + .49, 0);
	}

	recalcDefaultSizes(orderModel: IOrderModel): IOrderModel {
		orderModel.orderSpecs.systemSqft = this.calcSystemSize(orderModel.orderSpecs);
		orderModel.orderSpecs.totalSqft = this.calcSystemSize(orderModel.orderSpecs, true);

		if (orderModel.orderSpecs.slackOverride === false) {
			if (orderModel.orderSpecs.guideType === "Topguide") {
				orderModel.orderSpecs.slack = 7;
			}
			else {
				const gsFeet = orderModel.orderSpecs.guideSpaceFeet || 0;
				if (gsFeet <= 10)
					orderModel.orderSpecs.slack = 4;
				else if (gsFeet <= 20)
					orderModel.orderSpecs.slack = 5;
				else
					orderModel.orderSpecs.slack = 6;
			}
		}

		if (orderModel.orderSpecs.rollerWrapOverride === false) {
			orderModel.orderSpecs.rollerWrap = 3;
		}

		return orderModel;
	}
}
